import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

const Breadcrumbs = ({ items = [] }) => {
  const location = useLocation();
  // Reset scroll on route change (helps SPAs)
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <nav
      aria-label="Breadcrumb"
      className="bg-[#0A0A0A] border-b border-white/5"
    >
      <ol className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center gap-2 text-xs sm:text-sm text-white/60 flex-wrap">
        <li>
          <Link
            to="/"
            className="flex items-center gap-1 hover:text-[#E11D26] transition-colors"
          >
            <Home className="h-3.5 w-3.5" />
            <span className="sr-only sm:not-sr-only">Home</span>
          </Link>
        </li>
        {items.map((item, idx) => {
          const isLast = idx === items.length - 1;
          return (
            <React.Fragment key={idx}>
              <ChevronRight className="h-3.5 w-3.5 text-white/30" />
              <li>
                {isLast ? (
                  <span className="text-white font-semibold uppercase tracking-wider">
                    {item.name}
                  </span>
                ) : (
                  <Link
                    to={item.path}
                    className="hover:text-[#E11D26] transition-colors uppercase tracking-wider"
                  >
                    {item.name}
                  </Link>
                )}
              </li>
            </React.Fragment>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
